package com.eladfinish.bible.contest.features.installTime.domain.repository

import com.eladfinish.bible.contest.features.installTime.domain.model.InstallEvent
import com.eladfinish.bible.contest.features.installTime.domain.model.InstallInfo
import com.eladfinish.bible.contest.features.installTime.platform.AppInstallInfoProvider

interface InstallInfoRepository {
    fun getInstallInfo(): InstallInfo?
}

class DefaultInstallInfoRepository(
    private val provider: AppInstallInfoProvider,
) : InstallInfoRepository {

    override fun getInstallInfo(): InstallInfo? {
        val firstInstall = provider.firstInstallTimeMillis()
        val lastUpdate = provider.lastUpdateTimeMillis()

        // If platform cannot provide data, fail gracefully
        if (firstInstall == null || lastUpdate == null) {
            return null
        }

        val event = when {
            firstInstall == lastUpdate ->
                InstallEvent.FIRST_INSTALL

            lastUpdate > firstInstall ->
                InstallEvent.UPDATE

            else ->
                InstallEvent.NONE
        }

        return InstallInfo(
            firstInstallTimeMillis = firstInstall,
            lastUpdateTimeMillis = lastUpdate,
            event = event,
        )
    }
}
